import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import reducers from "reducers";

function reduxStore(initialState) {
  const sagaOptions = {
    onError: (error, info) => {
      console.error(error);
      console.info(info);
    },
  };
  const sagaMiddleware = createSagaMiddleware(
    process.env.NODE_ENV && process.env.NODE_ENV !== "production"
      ? sagaOptions
      : undefined,
  );
  const store = {
    ...configureStore({
      reducer: reducers,
      middleware: () => {
        const middlewares = [sagaMiddleware];
        if (process.env.NODE_ENV && process.env.NODE_ENV !== "production") {
          middlewares.push(logger);
        }
        return middlewares;
      },
      devTools: process.env.NODE_ENV && process.env.NODE_ENV !== "production",
      initialState,
    }),
    runSaga: sagaMiddleware.run,
  };

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", () => {
      // We need to require for hot reloading to work properly.
      const nextReducer = require("../reducers");

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

export default reduxStore;
